<div #wrapper class="view-recipe-wrapper">
    <app-modal-header [text]="'Изтриване на рецепти'" [bold]="true" (close)="bsModalRef.hide()"></app-modal-header>

    <div class="modal-body" [ngClass]="isIOS() === true ? 'ios' : ''">
        <ul class="dates">
            <li *ngFor="let date of dates; let i = index">
                <div class="form-group" (click)="(!isAllowed && i >= 3 ? openUpgradeModal() : null)">
                    <div class="form-check">
                        <label class="form-check-label">
                            <i *ngIf="(!isAllowed && i >= 3)" class="date-lock fa fa-lock"></i>

                            <input
                                    class="form-check-input"
                                    name="date"
                                    type="checkbox"
                                    [disabled]="!isAllowed && i >= 3"
                                    (click)="(!isAllowed && i >= 3 ? openUpgradeModal() : markDayAsSelected(date.date))"
                                    value="">
                            {{ date.date }} ({{ date.week_name }})
                            <i class="input-helper"></i>
                        </label>
                    </div>
                </div>
            </li>
        </ul>
    </div>

    <div class="modal-footer" [ngClass]="isIOS() === true ? 'ios' : ''">
        <button type="button" class="btn btn-danger" (click)="deleteAllRecipe()">{{ 'delete_all' | localise }}</button>

        <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">{{ 'back' | localise }}</button>
        <button type="button" class="btn btn-success" (click)="deleteRecipe()">{{ 'btn_delete' | localise }}</button>
    </div>
</div>
